export const breakpoints = {
  MOBILE: 580,
  TABLET_SMALL: 920,
  TABLET_LARGE: 1150,
  DESKTOP: 1290,
};
